const COUNT_KEYS = ['created', 'updated', 'skipped', 'failed']

export function build_sync_summary(result = {}) {
    const companies = to_counts('companies', result)
    const contacts = to_counts('contacts', result)
    const users = to_counts('users', result)

    return {
        companies: with_total(companies),
        contacts: with_total(contacts),
        users: with_total(users),
        total: sum(companies) + sum(contacts) + sum(users),
        error: result.error || null,
    }
}

export function build_dry_run_summary(report = {}) {
    const summary = report.summary || {}

    return {
        companies: to_dry_run_counts('companies', summary),
        contacts: to_dry_run_counts('contacts', summary),
        users: to_dry_run_counts('users', summary),
        mocoError: report.mocoError || null,
        issues: [
            ...collect_issues(report.companies, 'company', name_of_company),
            ...collect_issues(report.contacts, 'contact', name_of_contact),
            ...collect_issues(report.users, 'user', name_of_user),
        ],
    }
}

function to_counts(prefix, result) {
    return {
        created: result[prefix + 'Created'] || 0,
        updated: result[prefix + 'Updated'] || 0,
        skipped: result[prefix + 'Skipped'] || 0,
        failed: result[prefix + 'Failed'] || 0,
    }
}

function with_total(counts) {
    return { ...counts, total: sum(counts) }
}

function sum(counts) {
    return COUNT_KEYS.reduce((acc, key) => acc + (counts[key] || 0), 0)
}

function to_dry_run_counts(prefix, summary) {
    return {
        processed: summary[prefix + 'Processed'] || 0,
        ready: summary[prefix + 'Ready'] || 0,
        withErrors: summary[prefix + 'WithErrors'] || 0,
    }
}

function collect_issues(candidates, entityType, name_of) {
    return (candidates || []).reduce((issues, candidate) => {
        (candidate.issues || []).forEach(issue => {
            issues.push({
                entityType,
                entityName: name_of(candidate),
                severity: issue.severity,
                code: issue.code,
                message: issue.message,
            })
        })
        return issues
    }, [])
}

function name_of_company(candidate) {
    return candidate.name || '#' + candidate.mocoCompanyId
}

function name_of_contact(candidate) {
    return [candidate.firstname, candidate.lastname].filter(Boolean).join(' ') || '#' + candidate.mocoContactId
}

function name_of_user(candidate) {
    return [candidate.firstname, candidate.lastname].filter(Boolean).join(' ') || '#' + candidate.mocoUserId
}
